import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';


export default class SignInUpNav extends Component {
  render(){
    return(
      <nav className="navbar navbar-expand-sm navbar-light">
        <ul className="navbar-nav container">
          <li className="nav-item">
            <NavLink exact className="nav-link sign-nav" activeClassName="active" to="/guide">Water</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" to="/guide/electric">Electricity</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" to="/guide/natural-gas">Natural Gas</NavLink>
          </li>
        </ul>
      </nav>
    )
  }
}